import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    title: "Introduction",
    body: [
      "Carlton Wellness Center (\"we\", \"us\", \"our\"), an EBG Group company, is committed to protecting the privacy of every visitor, member and enquirer. This Privacy Policy explains what personal information we collect through www.carltonwellness.com and at our wellness centers, how we use it, and the choices available to you.",
    ],
  },
  {
    title: "Information We Collect",
    body: ["We collect information you voluntarily provide to us, including:"],
    list: [
      "Contact details — name, phone number, email address and city, when you book an assessment, enquire about memberships or franchises, or contact us.",
      "Wellness goals and messages you share in enquiry forms.",
      "Health and lifestyle information shared during assessments at our centers (collected offline with your consent).",
      "Basic technical data such as browser type and pages visited, used to improve the website experience.",
    ],
  },
  {
    title: "How We Use Your Information",
    body: ["Your information is used only to:"],
    list: [
      "Respond to your enquiries and schedule wellness assessments.",
      "Design and deliver personalised wellness protocols and memberships.",
      "Share relevant updates about programs, offers and new centers (you may opt out anytime).",
      "Evaluate franchise and partnership enquiries.",
      "Improve our services, website and member experience.",
    ],
  },
  {
    title: "Data Sharing & Disclosure",
    body: [
      "We do not sell, rent or trade your personal information. Information may be shared only with our internal teams, our parent company EBG Group, and trusted service providers who assist in operating our services — all bound by confidentiality obligations — or where disclosure is required by law.",
    ],
  },
  {
    title: "Health Information",
    body: [
      "Any health, body-composition or lifestyle information collected during your assessments is treated as sensitive personal data. It is accessed only by the doctors, therapists and nutritionists involved in your care and is never used for marketing without your explicit consent.",
    ],
  },
  {
    title: "Data Security & Retention",
    body: [
      "We use reasonable administrative, technical and physical safeguards to protect your information. Enquiry data is retained only for as long as needed to serve you and meet legal requirements, after which it is securely deleted.",
    ],
  },
  {
    title: "Your Rights",
    body: [
      "You may request access to, correction of, or deletion of your personal information, and may withdraw consent for marketing communication at any time by writing to info@carltonwellnesscenter.com.",
    ],
  },
  {
    title: "Cookies",
    body: [
      "Our website may use minimal cookies and similar technologies to remember preferences and understand website usage. You can disable cookies in your browser settings; the website will continue to function.",
    ],
  },
  {
    title: "Updates to This Policy",
    body: [
      "We may update this Privacy Policy from time to time. The revised version will be posted on this page with an updated date. Continued use of our website constitutes acceptance of the updated policy.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      crumb="Privacy Policy"
      line1="Your Privacy,"
      line2="Our Promise."
      updated="June 2026"
      sections={SECTIONS}
    />
  );
}
